import { render, staticRenderFns } from "./ProveedorVerOrdenCompra.vue?vue&type=template&id=7a5f542c&scoped=true&"
import script from "./ProveedorVerOrdenCompra.vue?vue&type=script&lang=js&"
export * from "./ProveedorVerOrdenCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f542c",
  null
  
)

export default component.exports